import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "./index.js"

// Shared component
import Navigation from "./components/Navigation";
import PageTransition from "./pages/PageTransition.jsx";
import AnimatedPage from "./pages/AnimatedPage.jsx";

// Home Page Components
import HeroSlider from "./components/HeroSlider";
import Hero from "./components/Hero";
import VisionSection from "./components/VisionSection";
import HomeEnd from "./components/HomeEnd";

// About Us Pages
import AboutUs from "./pages/AboutUs"; 
import AboutScroll from "./pages/AboutScroll";

// Service Pages
import Services from "./pages/Services";

// Testimonials
import Testimonials from "./pages/Testimonials.jsx";

//Contact Form
import Contact from "./pages/Contact.jsx";

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <>
      <PageTransition /> {/* Logo splash on every route change */}
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route
            path="/"
            element={
              <AnimatedPage>
                <HeroSlider />
                <Hero />
                <VisionSection />
                <HomeEnd />
              </AnimatedPage>
            }
          />
          <Route
            path="/about-us"
            element={
              <AnimatedPage>
                <AboutUs />
                <AboutScroll />
              </AnimatedPage>
            }
          />
          <Route
            path="/services"
            element={
              <AnimatedPage>
                <Services />
              </AnimatedPage>
            }
          />
          <Route
            path="/test"
            element={
              <AnimatedPage>
                <Testimonials />
              </AnimatedPage>
            }
          />
          <Route
            path="/contact"
            element={
              <AnimatedPage>
                <Contact />
              </AnimatedPage>
            }
          />
        </Routes>
      </AnimatePresence>
    </>
  );
}

function App() {
  return (
    <Router>
      <Navigation />
      <AnimatedRoutes />
    </Router>
  );
}

export default App;
